import { ComponentsStore } from './../core-services/components/components.store';
import * as _ from "lodash";
import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { faSearch, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { takeUntil } from "rxjs/operators";
import { Observable } from "rxjs";

import { BaseComponent } from "../base.component";
import { Game } from "../core-services/games/games.model";
import { GamesStore } from "../core-services/games/games.store";
import { CoreService } from "../core-services/core.service";
import { GamesResultsComponent } from '../games-results/games-results.component';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PrefixLangs } from "../core-services/core.models";

export const SEARCH_SELECTOR = "whg-search";

/*
*     Angular does not support embedding one web component into another,
*     Therefore we need to define this component with seperete selector to use it both externally
*     and within other Angular ELements,
*     see: https://github.com/angular/angular/issues/25525
*/
@Component({
  selector: `${SEARCH_SELECTOR}-internal`,
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
})
export class SearchComponent extends BaseComponent implements OnInit, OnDestroy {
  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modalService.dismissAll();
    this.searchInput = '';
  }
  @ViewChild("searchInputField") searchInputField: ElementRef;
  faSearch: IconDefinition = faSearch;
  searchInput: string;

  private allGames: Game[];
  private filetredResults: Game[];
  private allGames$: Observable<Game[]>;

  get langPrefix(): string {
    return this.coreService.getLangPrefix(this.jurisdiction, PrefixLangs.Search);
  }

  constructor(
    private readonly gamesStore: GamesStore,
    private modalService: NgbModal,
    private componnetStore: ComponentsStore
  ) {
    super();
    this.allGames$ = this.gamesStore.allGames$;
  }

  ngOnInit() {
      this.gamesStore.getGames();

      this.allGames$.pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
          this.allGames = _.cloneDeep(data);
      });
  }

  filterGames(): void {
    const searchInput = this.searchInput;
    this.componnetStore.addSearchedGames(searchInput);

    if (this.searchInput !== '') {
      this.filetredResults = this.allGames.filter((game) => {
        return (
          game.name.toLowerCase().includes(searchInput.toLowerCase()) ||
          game.provider.toLowerCase().includes(searchInput.toLowerCase())
        );
      });
      this.gamesStore.addFilteredGames(this.filetredResults);
      // open search modal on no mobile devices
      if(this.coreService.getScreenWidthFromWindow() > 768) {
        if(!this.coreService.isModalOpenedByAriaLabel('search-modal-title')) {
          const modalState = {
            modal : true,
            desc : 'modal opened'
          };
          history.pushState(modalState, null);
          this.coreService.removeFirstElementByTagName('ngb-modal-backdrop');
        }
      }
    } else {
      this.componnetStore.addSearchedGames('');
      this.gamesStore.addFilteredGames([]);
      if(this.coreService.getScreenWidthFromWindow() > 768) {
        this.modalService.dismissAll();
      }
    }

  }

  ngOnDestroy() {
    // reset data once search is closed
    this.searchInput = '';
    this.filterGames();
  }
}
